import { useQuery } from 'react-query';
import { GetResearchAnalystsDetails } from 'services/apiServices';
import { Errors, TGetResearchAnalystsDetailResult } from 'types/ApiServicesTypes';

export default function useGetResearchAnalystsDetails(ra_id: number) {
  const objQuery = useQuery<TGetResearchAnalystsDetailResult, Errors>(
    ['GetResearchAnalystsDetails'],
    () => GetResearchAnalystsDetails(ra_id),
  );
  return objQuery;
}
